import { ArchiveCogIcon } from './ArchiveCogIcon';

/**
 * author: Colton Wiscombe
 * id 3B5F3441-7A3E-4CF1-933B-F5FCF801CB8E
 * name archive-cog
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-cog.svg
 * tags
 * - Settings 
 */
export const BoxCogIcon = ArchiveCogIcon;
export default BoxCogIcon